<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_PurchasePlan' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item txPurchasePlans">
      <div class="bg-white fh" id='txPurchasePlans-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'planCode'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'txPurchasePlans')">{{ scope.row.planCode }}</a>
                </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txPurchasePlans-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData" :soltNameArray="soltNameArray">
        <template slot="fileup">
          <el-button icon="el-icon-folder-opened" type="primary" @click="uploadRow">批量上传</el-button>
        </template>
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="txPurchasePlans-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp" :soltNameArray="soltNameArray">
        <template slot="fileup">
          <el-button icon="el-icon-folder-opened" @click="uploadRow">批量上传</el-button>
        </template>
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
      <input ref="uploadInput" @change="handleChange" type="file" :style="{width:0, height: 0}" name="files"/>
    </div>
  </div>
</template>

<script>
import * as txPurchasePlans from '@/api/tx_purchaseplans';
import mytable from '@/utils/crmtableFlowV2';
import { getToken } from '@/utils/auth';

export default {
  name: 'txPurchasePlans',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_PurchasePlan',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: '',
        accName: '',
        eRPDeptName: '',
        planDetail: []
      },
      soltNameArray: ['fileup'],
      action: process.env.VUE_APP_BASE_API,
      rules: {}
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.initData.accName = this.currentAccName;
    if (this.accList) {
      const tempaccindex = this.accList.findIndex(u => u.accountId === this.initData.AccountId);
      if (tempaccindex > -1) {
        this.initData.erpDeptName = this.accList[tempaccindex].erpDeptName;
        this.initData.erpUser = this.accList[tempaccindex].erpUser;
      }
    }
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return txPurchasePlans;
    },
    uploadRow() {
      this.$refs.uploadInput.click();
    },
    handleChange() {
      // 选择文件后触发
      const files = this.$refs.uploadInput.files;
      if (files.length > 1) {
        this.$notify({
          title: '警告',
          message: '只能选择一个文件，上传失败',
          type: 'warning',
          duration: 0
        });
      }
      const file = files[0];
      if (file.size > 5 * 1024 * 1024) {
        this.$notify({
          title: '警告',
          message: '文件:' + file.name + '过大，上传失败',
          type: 'warning',
          duration: 0
        });
        return;
      }
      const reader = new FileReader();// 文件类
      const loading = this.$loading({
        lock: true,
        text: '读取文件中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      reader.readAsDataURL(file); // 读取文件
      reader.onload = () => {
        this.$nextTick(() => {
          this.uplaodAction(reader.result, file, loading);// 文件上传
        });
      };
      this.$refs.uploadInput.value = '';
    },
    // 上传
    uplaodAction(res, file, loading) {
      const xhr = new XMLHttpRequest();
      const url = this.action + '/Tx_PurchasePlans/regUpload?AccountId=' + this.currentAccId;
      xhr.open('POST', url, true);
      xhr.setRequestHeader('X-Token', getToken()); // 添加token
      const formData = new FormData();
      formData.append('files', file);
      xhr.send(formData);// 添加上传的文件
      xhr.onreadystatechange = () => {
        // 上传返回
        if (xhr.readyState === 4) {
          console.log(xhr.response);
          const resData = JSON.parse(xhr.response);
          if (resData.code !== 200) {
            this.$notify({
              title: '警告',
              message: '文件上传失败:' + resData.message,
              type: 'warning',
              duration: 0
            });
          } else {
            if (resData.result && resData.result.length > 0) {
              const detail = this.formref.GetModelData('planDetail');
              for (let i = 0; i < resData.result.length; i++) {
                detail.push({ ...{}, ...resData.result[i] });
              }
              this.formref.AssignmentModel('planDetail', detail);
            }
          }
        }
        loading.close();
      };
      xhr.onprogress = (res) => {
        if (res.currentTarget.status !== 200) {
          this.$message.error(res.currentTarget.responseText);
        }
      };
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnDelNew':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录删除',
              type: 'error'
            });
            return;
          }
          this.Delnew();
          break;
        case 'btncancel':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          }
          this.cancel();
          break;
        case 'btncommit':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请最少提交一条记录',
              type: 'error'
            });
            return;
          }
          this.commit();
          break;
      }
    },
    Delnew() {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const paramStr = JSON.stringify({
          keyValue: this.multipleSelection[0].id,
          AccountId: this.getAccountId()
        });
        this.listLoading = true;
        txPurchasePlans.Delete(paramStr).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList();
          this.listLoading = false;
        }).catch((_) => {
          this.listLoading = false;
        });
      }).catch(() => {
      });
    },
    cancel() {
      this.$confirm('是否确认撤回?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const paramStr = JSON.stringify({
          keyValue: this.multipleSelection[0].id,
          AccountId: this.getAccountId()
        });
        this.listLoading = true;
        txPurchasePlans.Cancel(paramStr).then(res => {
          this.$message({
            message: '撤回成功',
            type: 'success'
          });
          this.getList();
          this.listLoading = false;
        }).catch((_) => {
          this.listLoading = false;
        });
      }).catch(() => {
      });
    },
    commit() {
      this.$confirm('是否确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const conforms = this.multipleSelection.filter(u => u.state === 0 || u.state === 2);
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: conforms.map(u => u.id).join(','),
          AccountId: this.getAccountId()
        });
        this.listLoading = true;
        if (conforms && conforms.length > 0) {
          txPurchasePlans.Commit(paramStr).then(res => {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            this.getList();
            this.listLoading = false;
          }).catch((_) => {
            this.listLoading = false;
          });
        } else {
          this.$message({
            message: '请选择状态为草稿或已退回的单据!',
            type: 'error'
          });
          this.getList();
        }
      }).catch(() => {
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txPurchasePlans') {
        this.getApi().get(row.id).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_purchaseplansview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txPurchasePlans-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}

.txPurchasePlans .edit_dialog {
  height: calc(100vh - 106px) !important;
  box-sizing: border-box;
}

.txPurchasePlans .el-dialog {
  margin: 0 !important;
  box-sizing: border-box;
  width: 100% !important;

}

</style>
